import React from 'react';
import { toastPromise } from '../Helpers/ToastMessage';
import 'react-image-upload/dist/index.css';
import { useCompany } from '../Store/storeFunctions';
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  useCSVReader,
  lightenDarkenColor,
  formatFileSize,
} from 'react-papaparse';

import TiptapEmailTemplate from '../Form/BuilderTools/TipTapEmailTemplate';

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { FormikSelect, FormikTextAreaInput, FormikTextInput } from '../FormikFields';

const GREY = '#CCC';
const GREY_LIGHT = 'rgba(255, 255, 255, 0.4)';
const DEFAULT_REMOVE_HOVER_COLOR = '#A01919';
const REMOVE_HOVER_COLOR_LIGHT = lightenDarkenColor(
  DEFAULT_REMOVE_HOVER_COLOR,
  40
);
const GREY_DIM = '#686868';

const functions = getFunctions();
const sendBulkEmail = httpsCallable(functions, "sendBulkEmail");

function SendAnEmail(props) {
  const [emailTemplate, setEmailTemplate] = React.useState("<p></p>");
  const [emailConfig, setEmailConfig] = React.useState({
    toHeader: '',
    subject: ''
  });
  const [seed, setSeed] = React.useState(0);
  const [csvHeaders, setCsvHeaders] = React.useState([]);
  const [csvInterpolations, setCsvInterpolations] = React.useState([]);
  const [csvData, setCsvData] = React.useState([]);

  const company = useCompany();

  const { CSVReader } = useCSVReader();
  const [zoneHover, setZoneHover] = React.useState(false);
  const [removeHoverColor, setRemoveHoverColor] = React.useState(
    DEFAULT_REMOVE_HOVER_COLOR
  );

  const EmailSchema = Yup.object().shape({
    toHeader: Yup.string().required('Required'),
    subject: Yup.string().required('Required')
  });

  function sendEmails(newEmailConfig){
    toastPromise(async () => {
      var sendData = {
        companyId: company.companyData.code,
        recipients: csvData,
        subject: newEmailConfig.subject,
        toEmailField: newEmailConfig.toHeader,
        messageBody: emailTemplate,
        interpolations: interpolationList()
      };

      console.log(sendData);
      await sendBulkEmail(sendData);
      
      setEmailConfig({
        toHeader: ''
      });

      setCsvData([]);
      setCsvHeaders([]);
      setCsvInterpolations([]);
      setEmailTemplate("<p></p>");
      setSeed(seed+1);
    });
  }
  
    var interpolationList = React.useCallback((options) => {
      var query = options?.query;
  
      var interpolations = [
          { ID: "CompanyName", Label: "Company Data - Name" },
          { ID: "CompanyEmail", Label: "Company Data - Email" },
          { ID: "CompanyWebsite", Label: "Company Data - Website" },
          { ID: "CompanyPortal", Label: "Company Data - Portal" },
          { ID: "CompanyPhone", Label: "Company Data - Phone" },
          { ID: "CompanyAddress", Label: "Company Data - Address" },
          { ID: "IndividualFormLink", Label: "Individual - Form Link" },
          { ID: "BusinessFormLink", Label: "Business - Form Link" },
          { ID: "TrustFormLink", Label: "Trust - Form Link" },
          ...csvInterpolations
      ];
  
      if (query) {
          return interpolations.filter(i => i.Label.toLowerCase().startsWith(query.toLowerCase()));
      }
  
      return interpolations;
    }, [csvInterpolations]);

  function render() {
    return (
      <div style={{ backgroundColor: '#F3F9FF', paddingTop: '2vh' }} key={seed}>
        <div className="container">
          <div style={{ marginBottom: 10, textAlign: 'center' }}>
            <h3>Create an email to be sent to your clients.</h3>
          </div>

          <div className="row">
            <CSVReader
              onUploadAccepted={(results) => {
                var headers = results.data[0].map(v => {
                  var obj = {};

                  obj.text = v;
                  obj.value = v;

                  return obj;
                });
                var interpolations = results.data[0].map(v => {
                  var obj = {};

                  obj.Label = v;
                  obj.ID = v;

                  return obj;
                });
                setCsvHeaders(headers);
                setCsvInterpolations(interpolations);
                setCsvData(results.data);
                
                setZoneHover(false);
              }}
              onDragOver={(event) => {
                event.preventDefault();
                setZoneHover(true);
              }}
              onDragLeave={(event) => {
                event.preventDefault();
                setZoneHover(false);
              }}
            >
              {({
                getRootProps,
                acceptedFile,
                ProgressBar,
                getRemoveFileProps,
                Remove,
              }) => (
                <>
                  <div
                    {...getRootProps()}
                    style={Object.assign(
                      {},
                      styles.zone,
                      zoneHover && styles.zoneHover
                    )}
                  >
                    {acceptedFile ? (
                      <>
                        <div style={styles.file}>
                          <div style={styles.info}>
                            <span style={styles.size}>
                              {formatFileSize(acceptedFile.size)}
                            </span>
                            <span style={styles.name}>{acceptedFile.name}</span>
                          </div>
                          <div style={styles.progressBar}>
                            <ProgressBar />
                          </div>
                          <div
                            {...getRemoveFileProps()}
                            style={styles.remove}
                            onMouseOver={(event) => {
                              event.preventDefault();
                              setRemoveHoverColor(REMOVE_HOVER_COLOR_LIGHT);
                            }}
                            onMouseOut={(event) => {
                              event.preventDefault();
                              setRemoveHoverColor(DEFAULT_REMOVE_HOVER_COLOR);
                            }}
                          >
                            <Remove color={removeHoverColor} />
                          </div>
                        </div>
                      </>
                    ) : (
                      'Drop CSV file here or click to upload'
                    )}
                  </div>
                </>
              )}
            </CSVReader>

            <div className="col-12">
              <Formik
                initialValues={emailConfig}
                validationSchema={EmailSchema}
                onSubmit={values => {
                  // same shape as initial values
                  setEmailConfig(values);
                  sendEmails(values);
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    {
                      !csvHeaders.length ? null :
                      <Field errors={errors} name="toHeader" component={FormikSelect} values={csvHeaders} formiklabel="To Email Address (Header from CSV)" />
                    }

                    <Field errors={errors} name="subject" component={FormikTextInput} formiklabel="Subject" />
                    
                    <TiptapEmailTemplate itemResource={interpolationList} seed={seed} value={emailTemplate} setValue={(v) => setEmailTemplate(v)} />

                    <div className="mb-3 mt-3 center"> 
                      <button className="btn btn-sm btn-primary" type="submit" disabled={!csvData?.length}>Send Email(s)</button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return render();
}

const styles = {
  taxicons: {
    width: '100%',
    marginTop: '20%'
  },
  zone: {
    alignItems: 'center',
    border: `2px dashed ${GREY}`,
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: 20,
  },
  file: {
    background: 'linear-gradient(to bottom, #EEE, #DDD)',
    borderRadius: 20,
    display: 'flex',
    height: 120,
    width: 120,
    position: 'relative',
    zIndex: 10,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
    paddingRight: 10,
  },
  size: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    marginBottom: '0.5em',
    justifyContent: 'center',
    display: 'flex',
  },
  name: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    fontSize: 12,
    marginBottom: '0.5em',
  },
  progressBar: {
    bottom: 14,
    position: 'absolute',
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
  },
  zoneHover: {
    borderColor: GREY_DIM,
  },
  default: {
    borderColor: GREY,
  },
  remove: {
    height: 23,
    position: 'absolute',
    right: 6,
    top: 6,
    width: 23,
  },
}

export default SendAnEmail;